import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      title: t('howItWorks.step1Title'),
      description: t('howItWorks.step1Desc'),
    },
    {
      number: "02",
      title: t('howItWorks.step2Title'),
      description: t('howItWorks.step2Desc'),
    },
    {
      number: "03",
      title: t('howItWorks.step3Title'),
      description: t('howItWorks.step3Desc'),
    },
    {
      number: "04",
      title: t('howItWorks.step4Title'),
      description: t('howItWorks.step4Desc'),
    },
  ];

  return (
    <section id="how-it-works" className="py-section-lg bg-background">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mb-10 lg:mb-20">
          <p className="text-label text-muted-foreground mb-2 lg:mb-4">{t('howItWorks.label')}</p>
          <h2 className="text-display-md font-serif text-foreground mb-3 lg:mb-6">
            {t('howItWorks.headline')}
          </h2>
          <p className="text-body text-muted-foreground text-base lg:text-lg">
            {t('howItWorks.description')}
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-10 lg:gap-y-16">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="group relative"
            >
              {/* Number */}
              <span className="text-7xl md:text-8xl font-serif text-secondary absolute -top-4 -left-4 select-none transition-colors duration-500 group-hover:text-muted">
                {step.number}
              </span>
              
              {/* Content */}
              <div className="relative pt-12 pl-8">
                <h3 className="text-display-sm font-serif text-foreground mb-4">
                  {step.title}
                </h3>
                <p className="text-body text-muted-foreground">
                  {step.description}
                </p>
              </div>

              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute -right-8 top-1/2 w-16 h-px bg-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
